// Astrea Ops - reminders that are emailed once (v7.74, 16 Oct 2026).
//
// The security vendor reminder is emailed once per project and start date. Whichever app notices
// it first claims it in the database (claim_project_reminder, in
// 20261016000001_vendors_contacts_country.sql); only the app that wins the claim sends the email.

import { supabase } from './supabaseClient';

// true when this app should send the reminder, false when it has already gone.
export async function claimProjectReminder(projectId, kind) {
  const { data, error } = await supabase.rpc('claim_project_reminder', { p_project_id: projectId, p_kind: kind });
  if (error) throw error;
  return data === true;
}

// v7.120 (29 Oct 2026): the estimated POM fee emails already sent for a project, oldest first
// ({kind: "pom_fee:<POM person id>:<fee in cents>:<number>", sent_at, sent_by}). Senior Management,
// Finance and System Admins only (project_pom_fee_emails, 20261029000001_pom_fee_email.sql); anyone
// else gets an empty list. Until that migration is run the call fails and the caller sends nothing.
export async function listPomFeeEmails(projectId) {
  const { data, error } = await supabase.rpc('project_pom_fee_emails', { p_project_id: projectId });
  if (error) throw error;
  return Array.isArray(data) ? data : [];
}
